import { render, staticRenderFns } from "./WholeLifePlan.vue?vue&type=template&id=22292d9c&scoped=true"
import script from "./WholeLifePlan.vue?vue&type=script&lang=js"
export * from "./WholeLifePlan.vue?vue&type=script&lang=js"
import style0 from "./WholeLifePlan.vue?vue&type=style&index=0&id=22292d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22292d9c",
  null
  
)

export default component.exports